import { PureComponent, ReactNode } from 'react';
import { getDoctorSelectorList } from '../../store/idbHandler';
import { Menu, Popover } from 'antd';
import { MyDoc } from '../../api/fetchMyProfile';

type Props = {
    children: JSX.Element;
    onSelect: (doc?: MyDoc) => void;
    className?: string;
    clinicId?: string;
    trigger?: 'click' | 'hover' | ['click', 'hover'];
};

class DoctorSelectorPopup extends PureComponent<Props> {
    myDocs?: MyDoc[] = getDoctorSelectorList();

    render(): ReactNode {
        const { children, onSelect, className, clinicId, trigger } = this.props;

        let myDocs = this.myDocs;

        if (clinicId) {
            myDocs = this.myDocs?.filter((doc) =>
                doc.professional.clinics?.some((clinic) => clinic._id === clinicId),
            );
        }

        if (!myDocs?.length || myDocs.length === 1) {
            return (
                <span onClick={() => onSelect(this.myDocs?.[0])} className={className || ''}>
                    {children}
                </span>
            );
        }

        return (
            <Popover
                content={
                    <Menu className="max-h-328 overflow-auto w-160">
                        {myDocs?.map((doc) => (
                            <Menu.Item key={doc.id} onClick={() => onSelect(doc)}>
                                {[doc.personal.name.f, doc.personal.name.l]
                                    .filter(Boolean)
                                    .join(' ')}
                            </Menu.Item>
                        ))}
                    </Menu>
                }
                className={className || ''}
                trigger={trigger}
            >
                <span>{children}</span>
            </Popover>
        );
    }
}

export default DoctorSelectorPopup;
